import React from 'react';
import {t} from '@lingui/core/macro';
import {Trans} from '@lingui/react';

import {useServerAlertRuleDelete} from 'features/server/model/useServerAlertRuleMutations';
import ConfirmModal from 'shared/ui/Modal/ConfirmModal/ConfirmModal';
import IServerAlertRule from 'features/server/model/ServerAlertRule/IServerAlertRule';

interface IServerAlertRuleDeleteModalProps {
    item: IServerAlertRule,
    open: boolean;
    handleClose: () => void;
}

const ServerAlertRuleDeleteModal: React.FC<IServerAlertRuleDeleteModalProps> = ({ item, open, handleClose }) => {
    const {remove, isLoading} = useServerAlertRuleDelete({uuid: item.uuid, handleClose});

    return (
        <ConfirmModal
            variant="delete"
            open={open}
            handleClose={handleClose}
            header={t`Удаление правила`}
            title={<Trans id="modal.serverAlertRule.delete.title" message="Удалить правило порога?"/>}
            hint={
                item.server === null && (
                    <Trans
                        id="modal.serverAlertRule.delete.accountHint"
                        message="Это правило действует на все серверы аккаунта."
                    />
                )
            }
            hintTone="warning"
            confirmText={t`Удалить`}
            onConfirm={remove}
            isLoading={isLoading}
        />
    );
};

export default ServerAlertRuleDeleteModal;
